import { Component, OnDestroy, type OnInit } from '@angular/core';
import { forkJoin, Subscription } from 'rxjs';
import { SolicitudesPagaresService } from '../../../../_services/solicitudes-pagares.service';
import { ExcelAvance } from '../../../../_models/excel-avance';
import { RxStompService } from '@stomp/ng2-stompjs';
import { AutenticacionService } from '../../../../_services/autenticacion.service';
import { Message } from '@stomp/stompjs';
import { NavService } from '../../../../_services/_nav.service';
import { Content } from '../../../../_models/solicitud-pagare';
import { ConfirmationService, TreeNode } from 'primeng/api';
import { UtilitiesService } from '../../../../utils/utilities.service';

@Component({
  selector: 'app-widget-anulacion-pagare',
  templateUrl: './widget-anulacion-pagare.component.html',
  styleUrls: ['./widget-anulacion-pagare.component.css']
})
export class WidgetAnulacionPagareComponent implements OnInit, OnDestroy {

  contador = 0;
  showModalSolicitudes = false;
  listSolicitudes: TreeNode[] = [];
  columnas: any[] = [];
  cargandoTabla = false;
  filtroBusqueda = '';

  excelAvance: ExcelAvance;
  modalVerificacion = {verificando: false, estActual: null, error: false, individual: false};
  private topSubscription: Subscription;

  filtroLazy: {
    cantidad: number,
    pagina: number,
    search: string | null
  } = {
    cantidad: 10,
    pagina: 0,
    search: null
  };
  page = 0;
  totalRegistros = 0;
  primeraFila = 0;
  rowsPerPage = 10;
  loading = false;

  constructor( private solicitudesPagaresService: SolicitudesPagaresService,
               private rxStompService: RxStompService,
               private authService: AutenticacionService,
               private navServicio: NavService,
               private confirmationService: ConfirmationService,
               public utilitiesService: UtilitiesService,){ }

  async ngOnInit(){
    this.columnas = [
      { field: 'fechaSolicitud', header: 'WIDGETS.LBL_FECHASOLICITUD'},
      { field: 'idSolicitudInterno', header: 'WIDGETS.LBL_NUMEROSOLICITUD' },
      { field: 'codigoTipoDocumento', header: 'WIDGETS.LBL_TIPODOCUMENTO' },
      { field: 'numeroDocumento', header: 'WIDGETS.LBL_NUMERODOCUMENTO' },
      { field: 'nombreCompleto', header: 'WIDGETS.LBL_NOMBRE' },
      { field: 'tipoVinculacion', header: 'WIDGETS.LBL_VINCULACION' },
      { field: 'estado', header: 'WIDGETS.LBL_ESTADO_SOLICITUD' },
      { field: 'acciones', header: 'LBL_ACCIONES' }
    ];
    window.onbeforeunload = () => this.ngOnDestroy();
    this.conectarSocket();
    await this.cargarContador();
  }

  async cerrarVerificacion(individual: boolean = false) {
    this.modalVerificacion.verificando = false;
    if (!individual) {
      this.showModalSolicitudes = false;
    } else {
      this.modalVerificacion.individual = false;
    }
    this.modalVerificacion.error = false;
    this.excelAvance = null;
    this.cargandoTabla = true;
    await this.cargarContador();
    this.cargandoTabla = false;
    if (individual) {
      this.visualizarSolicitudesPagare();
    }
  }

  async cargarContador() {
    this.loading = true;
    const [ contador ] = await forkJoin([ this.solicitudesPagaresService.contador() ]).toPromise();
    this.contador = contador;
    this.loading = false;
  }

  conectarSocket() {
    if (this.topSubscription) {
      this.topSubscription.unsubscribe();
    }
    this.topSubscription = this.rxStompService.watch('/topic/pendienteAnularPagre.' + this.authService.obtenerIdUsuarioLogueado()).subscribe(async (message: Message) => {
      const body = (message && message.body) ? JSON.parse(message.body) : null;
      if (body && this.excelAvance && this.excelAvance.uid === body.uid) {
        this.excelAvance.avance = body.avance;
        this.excelAvance.errores = body.errores ? body.errores : [];
        this.excelAvance.totalRegistros = body.totalRegistros;
        if ((this.excelAvance.avance * 100) >= 100) {
          this.modalVerificacion.estActual = 'FINVER';
          this.modalVerificacion.error = this.excelAvance.errores.length > 0;
        }
      }
    });
  }

  mostrarErrorEnModal(data: {[key:string]: any}, mensaje: string) {
    const simbolos = ['{', '}', '@', '"'];
    const contieneSimbolo = simbolos.some(simbolo => mensaje.includes(simbolo));

    const contienePunto = mensaje.includes('.') && mensaje[mensaje.length - 1] !== '.';

    const contieneNumero = /\d/.test(mensaje);

    const mismoErrorAnterior = mensaje === data.errorIntegracion;

    return contieneSimbolo || contienePunto || contieneNumero || mismoErrorAnterior;
  }


  visualizarSolicitudesPagare() {
    this.page = 0;
    this.primeraFila = 0;
    this.filtroBusqueda = '';
    this.filtroLazy.search = null;
    this.showModalSolicitudes = true;
    this.cargarSolicitudes(this.page, this.rowsPerPage);
  }

  buscarSolicitudes() {
    this.filtroLazy.search = this.filtroBusqueda?.trim() || null;
    this.page = 0;
    this.primeraFila = 0;
    this.cargarSolicitudes(0, this.rowsPerPage);
  }

  onFiltroCambiado(valor: string) {
    if (!valor || valor.trim() === '') {
      this.filtroLazy.search = null;
      this.page = 0;
      this.primeraFila = 0;
      this.cargarSolicitudes(0, this.rowsPerPage);
    }
  }

  onLazyLoadSolicitudes(event: any) {
    const cantidad = event && event.rows ? event.rows : this.rowsPerPage;
    const primeraFila = event && event.first ? event.first : 0;
    const pagina = Math.floor(primeraFila / cantidad);

    // Evitar doble consulta al abrir modal cuando PrimeNG dispara el primer lazy load.
    if (this.listSolicitudes.length > 0 && this.page === pagina && this.rowsPerPage === cantidad) {
      return;
    }

    this.cargarSolicitudes(pagina, cantidad);
  }

  private cargarSolicitudes(pagina: number, cantidad: number) {
    const request = Object.assign({}, this.filtroLazy, {
      pagina,
      cantidad
    });

    this.page = pagina;
    this.rowsPerPage = cantidad;
    this.primeraFila = pagina * cantidad;
    this.cargandoTabla = true;

    this.solicitudesPagaresService.listaAnuladoPagare(request).subscribe({
      next: (res) => {
        if (res && res.content) {
          this.listSolicitudes = this.agruparYAnidarSolicitudes(res.content);
          this.totalRegistros = res.totalElements || 0;
        } else {
          this.listSolicitudes = [];
          this.totalRegistros = 0;
        }
        this.cargandoTabla = false;
      },
      error: () => {
        this.cargandoTabla = false;
        this.mensajeError();
      }
    });
  }

  agruparYAnidarSolicitudes(solicitudes: Content[]): TreeNode[] {
    // Agrupar por idSolicitudInterno
    const grupos = new Map<number, Content[]>();
    
    solicitudes.forEach(solicitud => {
      if (!grupos.has(solicitud.idSolicitudInterno)) {
        grupos.set(solicitud.idSolicitudInterno, []);
      }
      grupos.get(solicitud.idSolicitudInterno).push(solicitud);
    });

    // Crear estructura anidada con titular como raíz
    const resultado: TreeNode[] = [];
    
    grupos.forEach((solicitudesDelGrupo) => {
      // Encontrar el titular (principal)
      const titular = solicitudesDelGrupo.find(s => s.tipoVinculacion === 'Titular');
      // Todos los demás registros como children (sin importar tipo de vinculación)
      const otros = solicitudesDelGrupo.filter(s => s.tipoVinculacion !== 'Titular');

      if (titular) {
        const nodoTitular: TreeNode = {
          data: titular,
          children: otros.map((registro: Content) => ({ data: registro }))
        };
        resultado.push(nodoTitular);
      } else if (otros.length > 0) {
        // Si no hay titular, usar el primer registro como nodo principal
        const principal = otros[0];
        const restantes = otros.slice(1);
        resultado.push({
          data: principal,
          children: restantes.map((registro: Content) => ({ data: registro }))
        });
      }
    });

    return resultado;
  }

  anularTodosPagare() {
    this.confirmationService.confirm({
      key: 'anulacion-pagare-widget',
      message: `¿Desea anular ${this.contador} pagarés masivamente?`,
      accept: () => {
        this.cargandoTabla = true;
        this.solicitudesPagaresService.anuladoPorIdUsuario().subscribe({
          next: (data) => {
            this.excelAvance = data;
            this.modalVerificacion.estActual = 'INIT';
            this.modalVerificacion.verificando = true;
            this.cargandoTabla = false;
          },
          error: () => {
            this.cargandoTabla = false;
            this.mensajeError();
          }
        });
      }
    });
  }

  anularPagare(row : any) {
    this.confirmationService.confirm({
      key: 'anulacion-pagare-widget',
      message: `¿Desea anular pagaré de la Unidad de Crédito ${this.formatearNombre(row.nombreCompleto)}?`,
      accept: () => this.ejecutarAnulacionPagare(row)
    });
  }

  private ejecutarAnulacionPagare(row: any) {
    this.cargandoTabla = true;
    this.modalVerificacion.estActual = 'INIT';
    this.modalVerificacion.verificando = true;
    this.modalVerificacion.individual = true;
    this.solicitudesPagaresService.anuladoPorIdSolicitudUC(row.idSolicitudUnidadCredito).subscribe(res => {
      this.cargandoTabla = false;
      if (res.error && !this.mostrarErrorEnModal(row, res.mensaje)) {
        this.navServicio.setMesage(0, {
          severity: 'info', summary: this.navServicio.buscarMensaje('LBL_INFORMACION'),
          detail: res.mensaje
        });
        this.modalVerificacion.estActual = null;
        this.cerrarVerificacion(true);
      } else {
        this.modalVerificacion.estActual = 'FINVER';
        if (res.error) {
          this.excelAvance = {} as ExcelAvance;
          this.excelAvance.errores = [];
          this.excelAvance.errores.push(res.mensaje);
          this.modalVerificacion.error = true;
        } else {
          this.mensajeExitoso();
          this.cargarContador();
          this.visualizarSolicitudesPagare();
        }
      }
    })
  }

  actualizarListado() {
    this.cargarSolicitudes(this.page, this.rowsPerPage);
  }

  formatearNombre(nombre: string): string {
    if (!nombre) return '';
    return nombre.toLowerCase().replace(/\b\w/g, c => c.toUpperCase());
  }

  mensajeExitoso() {
    this.navServicio.setMesage(0, {
      severity: "success",
      summary: this.navServicio.buscarMensaje("LBL_INFORMACION"),
      detail: this.navServicio.buscarMensaje("MSG_EXITOSERVICIO"),
    });
  }

  mensajeError() {
    this.navServicio.setMesage(0,
      {
        severity: 'error',
        summary: this.navServicio.buscarMensaje('LBL_INFORMACION'),
        detail: this.navServicio.buscarMensaje('WIDGETMODAL.MSG_ERRORINTEGRACIONES')
      });
  }


  ngOnDestroy() {
    if (this.topSubscription) {
      this.topSubscription.unsubscribe();
    }
  }

}
